const MS_PER_DAY = 24 * 60 * 60 * 1000;
const dayNumber = dateOnly => {
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(dateOnly !== null && dateOnly !== void 0 ? dateOnly : ''));
  return match ? Date.UTC(Number(match[1]), Number(match[2]) - 1, Number(match[3])) / MS_PER_DAY : NaN;
};

// The days of the bill period, both ends counted, or null when the screen has no usable period.
export const toPeriodDays = (startDateOnly, endDateOnly) => {
  const days = dayNumber(endDateOnly) - dayNumber(startDateOnly) + 1;
  return Number.isFinite(days) && days > 0 ? days : null;
};
const toWholeDays = d => Number.isFinite(d) && d > 0 ? Math.floor(d) : 0;

/*
 * The backend's split of an edited meter that has owner days (SubmeterShareSplitter.Split with the owner last):
 * the owner's days are the period's days no row covers, each row takes its days of the period rounded toward
 * zero to the cent, and the owner keeps the rest. Returns the cents of each row in the order given, or null
 * when there are no owner days (or no period), where the backend splits over the rows alone.
 */
export const splitCentsKeepingOwnerDays = (totalCents, rawDays, periodDays) => {
  if (!Number.isFinite(periodDays) || periodDays <= 0) return null;
  const days = rawDays.map(toWholeDays);
  if (periodDays - days.reduce((sum, d) => sum + d, 0) <= 0) return null;
  const safeTotalCents = Number.isFinite(totalCents) ? totalCents : 0;
  return days.map(d => Math.trunc(safeTotalCents * d / periodDays) || 0);
};